import type React from 'react';

import { useTheme } from '~ai-tutor/lib/useTheme';

const HaufeLogoIcon: React.FC<{ width?: number; height?: number; className?: string }> = ({
  width = 100,
  height = 100,
  className = '',
}) => {
  const { theme } = useTheme();
  const logoSrc =
    theme === 'dark'
      ? '/assets/haufe-akademie-rgb-logo-package/symbol/svg/haufe-akademie-rgb-symbol-white.svg'
      : '/assets/haufe-akademie-rgb-logo-package/symbol/svg/haufe-akademie-rgb-symbol-main.svg';

  return (
    <img
      src={logoSrc}
      alt="Haufe Symbol"
      width={width}
      height={height}
      className={className}
      loading="lazy"
      decoding="async"
    />
  );
};

export default HaufeLogoIcon;
